// Single source of truth for API bases. Auto-selects by environment — no
// comment/uncomment, no .env files, no build flags. The same build runs anywhere
// and picks the right API at runtime (mirrors the collexa_react structure).
//
// Resolution order:
//   1. window.__APP_CONFIG__.apiBase  -> optional runtime override injected at
//      container start. Used as `${apiBase}/api/v1/...`.
//   2. hostname auto-detection        -> localhost -> local, uat.* -> UAT, else prod.
//
// NOTE: bases keep a TRAILING SLASH — this app appends paths directly
// (e.g. `${BASE_URL}user/token/validate/`), unlike collexa which adds the slash.

const RUNTIME = (typeof window !== "undefined" && window.__APP_CONFIG__) || {};
const HOST = typeof window !== "undefined" ? window.location.hostname : "";

const ENVS = {
  local: {
    BASE_URL: "http://127.0.0.1:8000/",
    CMA_BASE_URL: "http://127.0.0.1:8001/",
    CMA_SUPPORT_URL: "http://127.0.0.1:8004/",
    DIGITAL_JOURNEY_BASE_URL: "http://127.0.0.1:8002/",
  },
  uat: {
    BASE_URL: "https://uat.zielfintech.com/api/v1/dashboard/",
    CMA_BASE_URL: "https://uat.zielfintech.com/api/v1/notification/",
    CMA_SUPPORT_URL: "https://uat.zielfintech.com/api/v1/support/",
    DIGITAL_JOURNEY_BASE_URL: "https://uat.zielfintech.com/api/v1/chat/",
  },
  production: {
    BASE_URL: "https://customer.zielfintech.com/api/v1/dashboard/",
    CMA_BASE_URL: "https://customer.zielfintech.com/api/v1/notification/",
    CMA_SUPPORT_URL: "https://customer.zielfintech.com/api/v1/support/",
    DIGITAL_JOURNEY_BASE_URL: "https://customer.zielfintech.com/api/v1/chat/",
  },
};

function resolveConfig() {
  // 1. explicit runtime override (container deploy) wins
  const apiBase = RUNTIME.apiBase && RUNTIME.apiBase.replace(/\/+$/, "");
  if (apiBase) {
    return {
      BASE_URL: `${apiBase}/api/v1/dashboard/`,
      CMA_BASE_URL: `${apiBase}/api/v1/notification/`,
      CMA_SUPPORT_URL: `${apiBase}/api/v1/support/`,
      DIGITAL_JOURNEY_BASE_URL: `${apiBase}/api/v1/chat/`,
    };
  }
  // 2. auto-detect by hostname
  if (HOST === "localhost" || HOST === "127.0.0.1") return ENVS.local;
  if (HOST.startsWith("uat.")) return ENVS.uat;
  return ENVS.production;
}

export const { BASE_URL, CMA_BASE_URL, CMA_SUPPORT_URL, DIGITAL_JOURNEY_BASE_URL } = resolveConfig();
